var exports = {
  "vF": "AccountTab.module__emailRow___b1VYYX",
  "c1": "AccountTab.module__emailText___b1VYYX",
  "aO": "AccountTab.module__emailTextSelectable___b1VYYX",
  "Rm": "AccountTab.module__toggleButton___b1VYYX",
};

module.exports = exports;
